import React, { useState, useContext, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import {
  SimpleLoading,
  VerifyContract,
  PromotionalFooterPure,
  CardTemplatePure,
  TitleTemplatePure
} from "../../pures";
import "./configuration-panel.css";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Context } from "../../../Context";
import { LocalStorageService } from "../../../services";

const ConfigurationPanelView = (props) => {
  const { setclientLogo, clientLogo } = useContext(Context);
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [logo, setLogo] = useState(clientLogo);
  const [fileLogo, setFileLogo] = useState(null);
  const [fileLogoName, setFileLogoName] = useState(null);
  const [redText, setRedText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    setLogo(clientLogo);
  }, [clientLogo]);


  const toggleDialog = () => {
    setVisible(!visible);
  };

  const handleClick = () => {
    inputRef.current.click();
  };

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        let im = new Image();
        im.src = e.target.result;
        let buffer = Buffer.from(
          e.target.result.substring(e.target.result.indexOf(",") + 1)
        );
        let mb = buffer.length / 1e6;
        // let byte = buffer.length
        im.onload = () => {
          if (mb < 2) {
            setFileLogoName(event.target.files[0].name);
            setFileLogo(event.target.files[0]);
            setLogo(e.target.result);
          } else if (mb > 2) {
            setRedText("La imagen debe pear menos de 2 MB");
            setTimeout(() => {
              setRedText("");
              event.target.value = null;
            }, 3500);
          }
        };
      };
      reader.readAsDataURL(event.target.files[0]);
      reader = null;
    }
  };
  const longmatches = useMediaQuery("(max-width:1200px)");

  const globalContainerStyles = {
    display: 'inline-block',
    maxWidth: '100%',
    backgroundColor: 'white',
    width: '100%',
    padding: '0px',
    justifyContent: 'center'
  };
  const containerTableAndHeadersStyles = {
    marginTop: "20px",
    maxWidth: "100%",
    justifyContent: "start",
  };

  if (longmatches) {
    globalContainerStyles.marginRight = 0;
  }

  return (
    <div className="standard-wrapper">
      {props.loading ? (
        <SimpleLoading />
      ) : props.contractPlanExist ? (
        <Container spacing={4} lg={12} md={12} style={globalContainerStyles}>
          <Container
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
            style={containerTableAndHeadersStyles}
          >
            <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
              <TitleTemplatePure title={props.title} />
            </Grid>
            <Grid
              container
              xs={12}
              lg={12}
              md={12}
              sm={12}
              es={12}
              className="configurationPanel-container-header"
            >
              <Grid
                item
                xs={6}
                lg={12}
                md={12}
                sm={12}
                es={12}
                className="container-cards-configurationPanel-view"
              >
                {props.cardConfiguration.map((item, index) => (
                  <Grid className="card-configurationPanel">
                    <CardTemplatePure {...item} key={index} />
                  </Grid>
                ))}
              </Grid>
              <Grid
                item
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                style={containerTableAndHeadersStyles}
              >
                <PromotionalFooterPure />
              </Grid>
            </Grid>
          </Container>
        </Container>
      ) : (
        <Container spacing={4} lg={12} md={12} style={globalContainerStyles}>
          {" "}
          <VerifyContract />
        </Container>
      )}
      {/* {visible && (
        <Dialog
          className="dialogAddLogo-container"
          title={"Agregar logo"}
          onClose={toggleDialog}
          width={500}
          height={550}
        >
          {isLoading ? (
            <div className="is-loading">
              <SimpleLoading />
            </div>
          ) : (
            <>
              <div className="dialogAddLogo-description">
                <p className="dialogAddLogo-grey-text">
                  Al cargar el logo de tu empresa en la plataforma, este se
                  visualizará en la parte superior de las pantallas.
                </p>
              </div>
              {logo && (
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className="dialogAddLogo-containerButtonsGroupStyles load-image"
                >
                  <img
                    src={logo}
                    alt="logo"
                    className="dialogAddLogo-img-style"
                  />
                </Grid>
              )}
              <Grid
                item
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                className="dialogAddLogo-containerButtonsGroupStyles-logo"
              >
                <button
                  onClick={handleClick}
                  className="dialogAddLogo-input-file"
                >
                  <i className="k-icon k-i-plus dialogAddLogo-plus-icon" />
                  <input
                    type="file"
                    id="fileKey"
                    accept="image/*"
                    ref={inputRef}
                    onChange={onImageChange}
                    className="dialogAddLogo-file"
                    required
                  />
                  {"Cargar logo"}
                </button>
                {!!logo && (
                  <span
                    className="button-signers delete"
                    onClick={() => setLogo(null)}
                  >
                    <i className="k-icon k-i-delete k-i-trash"></i>
                  </span>
                )}
              </Grid>
              {!!redText && <p className="red-text">{redText}</p>}
              <Grid
                item
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                className="dialogAddLogo-btnsLogo-container"
              >
                <button
                  className="dialogAddLogo-btn-cancel"
                  onClick={() => setVisible(false)}
                >
                  {t("dialogDeleteSigner.buttonCancel")}
                </button>
                <button
                  className={`dialogAddLogo-btn-cancel ${!!logo
                    ? "dialogAddLogo-accept-green"
                    : "dialogAddLogo-cancel-cursor"
                    }`}
                  onClick={async () => {
                    try {
                      if (!!logo) {
                        setIsLoading(true);
                        await props.sendClientImage(fileLogo);
                        let localStorageService = new LocalStorageService();
                        localStorageService.setLocalStorageItem(
                          "clientLogo",
                          logo ? logo : ""
                        );
                        setclientLogo(logo);
                        setVisible(false);
                      }
                    } catch (error) {
                      console.warn(error);
                    } finally {
                      setIsLoading(false);
                    }
                  }}
                >
                  {"Agregar"}
                </button>
              </Grid>
            </>
          )}
        </Dialog>
      )} */}
      {/* Page footer */}
      {/* <SimpleFooterPure /> */}
    </div>
  );
};

export { ConfigurationPanelView as default };
